import { ChevronLeft, ChevronRight, Sparkles } from 'lucide-react';
import { useState } from 'react';

/**
 * Painel lateral direito da tela de Atendimento — recolhe/expande por um
 * clique em qualquer ponto da coluna da borda. Por enquanto é só um
 * placeholder ("Em breve novidades!"); o conteúdo entra depois. A coluna
 * (25px) fica no mesmo lugar aberto ou fechado — só inverte a direção da seta.
 */
export function NovidadesPanel() {
  const [aberto, setAberto] = useState(false);

  // A coluna INTEIRA é o botão (dono, 17/out/2026): clicar em qualquer ponto
  // dela abre/fecha, não só no chevron.
  const ChevronBtn = (
    <button
      type="button"
      onClick={() => setAberto((v) => !v)}
      aria-label={aberto ? 'Fechar painel' : 'Abrir painel'}
      title={aberto ? 'Fechar painel' : 'Abrir painel'}
      className="flex w-[25px] flex-shrink-0 cursor-pointer items-center justify-center border-n-200 border-l bg-n-0 text-n-500 transition-colors hover:bg-n-50 hover:text-n-700"
    >
      {aberto ? (
        <ChevronRight size={20} strokeWidth={2} />
      ) : (
        <ChevronLeft size={20} strokeWidth={2} />
      )}
    </button>
  );

  if (!aberto) return ChevronBtn;

  return (
    <div className="flex min-h-0 flex-shrink-0">
      {ChevronBtn}
      <aside className="flex w-[340px] flex-shrink-0 flex-col bg-n-0">
        <div className="flex flex-1 flex-col items-center justify-center gap-[14px] p-[24px] text-center">
          <span className="flex h-[56px] w-[56px] items-center justify-center rounded-pill bg-brand-50 text-brand-600">
            <Sparkles size={26} strokeWidth={1.8} aria-hidden="true" />
          </span>
          <p className="font-semibold text-[15px] text-n-700">Em breve novidades!</p>
        </div>
      </aside>
    </div>
  );
}
